module.exports = __webpack_public_path__ + "img/vr_glasses.7edae4e6.svg";